<template>
    <el-card class="box-card" style="margin-bottom:10px;height:230px;">
        <div slot="header" class="clear-fix">
            <span>{{schemea.name}}</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="onUseSchemea()" >使用</el-button>
        </div>
 
            <span style="font-size:11px">筛选条件</span>
           <div>
                 <span class="filter-item" v-for="(key,index) in filterConditions"  :key="index" >{{key}} </span>
           </div>  
        <div>
        </div>
            <span style="font-size:11px">方案来源</span>
            <span style=" font-size:11px"> 自已</span>
        <!-- <div>
            <span>分享 </span>
        </div> -->
    </el-card>
</template>

<script> 
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
    name: 'searchplan',
    props:['schemea'],
     data() {
       return {
            filterConditions:this.initData(),
        }         
     },
      methods:{
            ...mapActions('saleanalysis', ['selectSavedSearchSchema']),
            ...mapMutations('saleanalysis', ['setCurrentSearchSchema','setSearchParams']),
         
               initData(){
                    var result =[];                
                     for(const key in this.schemea.searchParams)
                    {

                         var val = this.schemea.searchParams[key];
                         if(val.length>0)
                        {
                            result= result.concat(val);
                         }

                    } 
                    return result;
               },

               onUseSchemea()
               {
                 //  alert( JSON.stringify(this.schemea));
                   this.$emit('watchChild',this.schemea.name);
                   this.selectSavedSearchSchema(this.schemea.id);
                 //  self.setCurrentSearchSchema(this.schemea);
                   this.setSearchParams(  this.schemea.searchParams);
                   
               }
           }
}
</script>

<style>
    .clear-fix:before,
    .clear-fix:after {
        display: table;
        content: "";
    }

    .clear-fix:after {
        clear: both;
    }
</style>

